import { chakra, defineRecipe } from "@chakra-ui/react"

// NOTE: requires a parent with a "group" class.
// Reveals itself (using opacity) when the parent "group" is hovered.
// Always revealed on mobile.
export const revealOnGroupHoverRecipe = defineRecipe({
  base: {
    opacity: 0,
    height: 0,
    width: 0,
    transition: "opacity, width, height 0.2s ease-in-out",
    _groupHover: {
      opacity: 1,
      height: "auto",
      width: "auto"
    },
    _groupFocusWithin: {
      opacity: 1,
      height: "auto",
      width: "auto"
    },
    _focusWithin: {
      opacity: 1,
      height: "auto",
      width: "auto"
    },
    _hover: {
      opacity: 1,
      height: "auto",
      width: "auto"
    },
    // @ts-expect-error: TODO: get typing correct using chakra typegen https://chakra-ui.com/docs/get-started/cli#chakra-typegen
    _mediaHoverNone: {
      opacity: 1,
      height: "auto",
      width: "auto"
    },
    ["&:has([aria-expanded='true'])"]: {
      height: "auto",
      width: "auto",
      opacity: 1
    }
  }
})

import type { RecipeVariantProps } from "@chakra-ui/react"

type RevealOnGroupHoverVariantProps = RecipeVariantProps<
  typeof revealOnGroupHoverRecipe
>

export interface RevealOnGroupHoverProps
  extends React.PropsWithChildren<RevealOnGroupHoverVariantProps> {}

const RevealOnGroupHoverRecipe = chakra("div", revealOnGroupHoverRecipe)

export default RevealOnGroupHoverRecipe
